const _excluded = ["lookup", "onChange", "totalPossibleOptions"];function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var s = Object.getOwnPropertySymbols(e);for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (e.includes(n)) continue;t[n] = r[n];}return t;}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { Component } from 'react';
import debounce from "../../utils/debounce";
import { MultiSelect, defaultProps } from "./MultiSelect";











const uniqueOptions = (optionsValue) => (option, i, arr) =>
arr.findIndex((o) => o[optionsValue] === option[optionsValue]) === i;

function notEmpty(value) {
  return value !== null && value !== undefined;
}

export const debounceTime = 200;

export class LookupMultiSelect extends Component {


  static getDerivedStateFromProps(props) {
    return { totalPossibleOptions: props.totalPossibleOptions };
  }

  constructor(props) {
    super(props);
    this.state = {
      lookupOptions: [],
      selectedOptions: [],
      totalPossibleOptions: props.totalPossibleOptions
    };
    this.onChange = this.onChange.bind(this);
    this.onFilter = debounce(this.onFilter.bind(this), debounceTime);
  }

  onChange(value) {
    this.props.onChange(value);
    const options = this.combineOptions();

    const selectedOptions = value.
    map((v) => options.find((o) => o[this.props.optionsValue] === v)).
    filter(notEmpty);

    this.setState({ selectedOptions });
  }

  async onFilter(searchTerm) {
    if (searchTerm.length) {
      const { options, count } = await this.props.lookup(searchTerm);

      const lookupOptions = options.map((o) => _objectSpread(_objectSpread({},
      o), {}, {
        [this.props.optionsValue]: o.value,
        [this.props.optionsLabel]: o.label })
      );

      this.setState({ lookupOptions, totalPossibleOptions: count });
    }

    if (!searchTerm.length) {
      this.setState({
        lookupOptions: [],
        totalPossibleOptions: this.props.totalPossibleOptions
      });
    }
  }

  combineOptions() {
    return [
    ...this.props.options,
    ...this.state.lookupOptions,
    ...this.state.selectedOptions].
    filter(uniqueOptions(this.props.optionsValue));
  }

  render() {
    const _this$props = this.props,{ lookup, onChange, totalPossibleOptions } = _this$props,rest = _objectWithoutProperties(_this$props, _excluded);
    const filteredTotalPossibleOptions = this.state.totalPossibleOptions;
    return (/*#__PURE__*/
      React.createElement(MultiSelect, _extends({},
      rest, {
        onChange: this.onChange,
        onFilter: this.onFilter,
        totalPossibleOptions: filteredTotalPossibleOptions,
        options: this.combineOptions() })
      ));

  }
}_defineProperty(LookupMultiSelect, "defaultProps", _objectSpread(_objectSpread({}, defaultProps), {}, { value: [] }));